export default __webpack_public_path__ + "static/media/fruit-2048w.a46c6d2c.avif";